import React, { useEffect, useMemo, useState } from 'react'

import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import _ from 'lodash'
import { Button } from 'ziphy-web-shared/basic/lib/buttons'
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals'
import { $router } from 'ziphy-web-shared/basic/utils/router'
import { formatDate } from 'ziphy-web-shared/basic/utils/time'

import TimeSlotPicker from '@nedoShared/features/schedules/timeSlotPicker/TimeSlotPicker'

import { $booking } from '@store'

import BookingLayout from '../../library/bookingLayout/BookingLayout'
import withBookingDataInit from '../../library/withBookingDataInit/withBookingDataInit'
import SelectPracticeModal from '../../pages/bookingTimePicker/selectPracticeModal/SelectPractice.modal'

const BookingTimePickerPage = () => {
  const { t } = useTranslation()

  useEffect(() => {
    $booking.SET_FINISH_PRACTICE_ID(null)
  }, [])

  const [selectedWindow, setSelectedWindow] = useState({
    key: $booking.selectedTime,
    value: [],
  })

  const requestParams = useMemo(() => {
    // mock for dev
    //   return {
    //     practiceId: 1,
    //     serviceId: $booking.serviceId,
    //     placeId: 15,
    //     patientNumber: 1,
    //     symptomIds: [12, 135],
    //     begin: `$date:${begin.format('YYYY-MM-DDTHH:mm:ss')}`,
    //     end: `$date:${end.format('YYYY-MM-DDTHH:mm:ss')}`,
    //   }
    // mock for dev

    const result = {
      serviceId: $booking.serviceId,
      placeId: $booking.placeId,
      patientNumber: $booking.patients.selectedIds.length,
      symptomIds: $booking.$symptoms.selectedIds,
    }

    if ($booking.practiceId) {
      result.practiceId = $booking.practiceId
      result.officeId = $booking.officeId
    }

    return result
  }, [$booking.practiceId])

  // mock for dev
  // const timezone = $booking.$places.getById(requestParams.placeId).timezone
  // mock for dev

  const timezone = $booking.place.timezone

  const handleNext = () => {
    if (selectedWindow.value.length > 1) {
      const practices = $booking.servePractices
        .filter((item) => selectedWindow.value.includes(item.id))
        .map((item) => {
          const practiceService = _.find(
            $booking.practiceServices,
            ({ practiceId, serviceId }) =>
              practiceId === item.id && serviceId === $booking.serviceId,
          )

          return {
            practiceId: item.id,
            practiceName: item.name,
            price: practiceService?.price,
            currency: practiceService?.currency,
          }
        })

      $modal.add(SelectPracticeModal, {
        practices: practices,
        onSelect: (selected) => {
          $booking.SET_SELECTED_TIME(selectedWindow.key)
          $booking.SET_FINISH_PRACTICE_ID(selected)
          $router.executeAutoTarget($booking.schemaConfig?.nextStep())
        },
      })
    } else if (selectedWindow.value.length === 1) {
      $booking.SET_SELECTED_TIME(selectedWindow.key)
      $booking.SET_FINISH_PRACTICE_ID(selectedWindow.value[0])
      $router.executeAutoTarget($booking.schemaConfig?.nextStep())
    }
  }

  return (
    <BookingLayout
      breadcrumbs={['place', 'service', 'patients']}
      title={t('label.visit_date')}
      isMobileFooterFixed={true}
      isDesktopFooterFixed={true}
      button={
        <Button mode={['primary']} disabled={_.isEmpty(selectedWindow?.value)} onClick={handleNext}>
          {_.isEmpty(selectedWindow?.value)
            ? t('btn.select_time_slot')
            : formatDate(selectedWindow.key, {
                format: 'datetimeFullNoYear',
                timezone: timezone,
              })}
        </Button>
      }
    >
      <TimeSlotPicker
        value={selectedWindow}
        onChange={setSelectedWindow}
        requestParams={requestParams}
        placeTimezone={timezone}
      />
    </BookingLayout>
  )
}

export default withBookingDataInit('date', observer(BookingTimePickerPage))
